/**
 * 주어진 url로 json응답처리 하는 함수
 * - json 처리해서 네이티브 javascript 객체를 전달한다.
 */
export async function urlToJson(url) {
    return fetch(url, {
        headers: {
            "Accept": "application/json",
        },
    }).then((res) => {
        if (res.status !== 200) {
            let msg = '출력정보를 불러올 수 없습니다.';
            if (res.headers.has('gonelo-error-message-urlencoded')) {
                msg = decodeURI(res.headers.get('gonelo-error-message-urlencoded'));
            }
            throw new Error(msg);
        }
        //console.log(res);

        return res.json();

    });
}